module.exports = __webpack_public_path__ + "img/icon_location_2.4c22f949.svg";